@switch (model?.data && model?.type) {
@case ('page') {
<page-view [model]="$any(model)" />
}
@case ('category') {
@if ($any(model).data.pageTemplate === 'giftcards') {
<giftcards-category-view [model]="$any(model)" />
} @else {
<category-view [model]="$any(model)" />
}
}
@case ('product') {
<product-view [model]="$any(model)" />
}
@case ('store') {
<store-view [model]="$any(model)" />
}
@default {
<error-404 />
}
}